module.exports = __webpack_public_path__ + "media/images/flags/se-28aba54a61e5dcbd2dfea4f8d143b58d.svg";